// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/login-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2710%27 height=%276%27 viewBox=%270 0 10 6%27%3E%3Cpath d=%27M1 1l4 4 4-4%27 stroke=%27%23ffffff%27 stroke-width=%271.5%27 fill=%27none%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --white: #FFFFFF;
    --black: #000000;
    --primary: #1B13E3;
    --secondary: #48537B;
    --border: #DEE1E4;
}

body {
    font-family: 'Poppins';
    color: var(--secondary);
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    overflow-x: hidden;
    /* Prevent horizontal page scroll */
    background: #FCFCFC;
}

html {
    overflow-x: hidden;
    /* Prevent horizontal page scroll */
    max-width: 100vw;
    box-sizing: border-box;
}

*,
*::before,
*::after {
    box-sizing: border-box;
}

.btns {
    background: var(--primary);
    padding: 11px 24px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    color: var(--white);
    border: 1px solid var(--primary);
    min-width: 200px;
    text-align: center;
    border-radius: 12px;
    transition: all 0.3s ease;
}

.btns:hover {
    color: var(--primary);
    background: var(--white);
}

/* Secondary/cancel button. Mirrors .btns geometry exactly so a Cancel + confirm
   pair in a modal footer reads as one control group, but outlined instead of
   filled. Narrower min-width because a cancel action should not carry the same
   visual weight as the action it cancels. */
.btns-cancel {
    background: var(--white);
    padding: 11px 24px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    color: var(--secondary);
    border: 1px solid var(--border);
    min-width: 120px;
    text-align: center;
    border-radius: 12px;
    transition: all 0.3s ease;
}

.btns-cancel:hover {
    color: var(--primary);
    border-color: var(--primary);
    background: var(--white);
}

.form-group {
    margin-bottom: 24px;
}

.form-group label {
    display: block;
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
    color: var(--secondary);
    margin-bottom: 14px;
}

.form-control {
    width: 100%;
    padding: 0 16px;
    border: 1px solid #D1D5DB;
    border-radius: 12px;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    min-height: 55px;
    color: var(--secondary);
    border: 1px solid var(--border);
    box-shadow: 0px 2px 0px 0px #E7EBEE33 inset;
    background: #FCFCFC;
}

.form-control:focus {
    box-shadow: unset;
    border: 1px solid var(--primary);
}

.form-group .password-input {
    position: relative;
}

.form-group .password-input .form-control {
    padding-right: 60px;
}

.form-group .password-input .icon-btn {
    width: 54px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid var(--border);
    position: absolute;
    top: 7px;
    right: 0;
}

.form-group .password-input .icon-btn i {
    font-size: 20px;
    line-height: 20px;
    color: var(--secondary);
    cursor: pointer;
}

.remeber-forgot-box {
    margin-bottom: 40px;
}

.form-check-label {
    position: relative;
    display: block;
}

.form-check-label input {
    position: absolute;
    top: -100%;
    left: 0;
    opacity: 0;
    width: 0;
    height: 0;
}

.form-check-label span {
    position: relative;
    padding-left: 24px;
    display: block;
    font-size: 16px;
    line-height: 20px;
    color: var(--secondary);
    cursor: pointer;
}

.form-check-label span::before {
    content: '\\e902';
    width: 16px;
    height: 16px;
    border: 1px solid var(--border);
    font-family: 'icomoon' !important;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    position: absolute;
    font-size: 8px;
    line-height: 8px;
    font-weight: 900;
    color: transparent;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    background: var(--white);
    cursor: pointer;
    transition: all 0.3s ease;
}

.form-check-label input:checked~span::before {
    color: var(--white);
    background: var(--primary);
    border: 1px solid var(--primary);
}

/* Auth Page */
.auth-page {
    padding: 24px 0 24px 24px;
    min-height: 100dvh;
    display: flex;
}

.auth-page .btns {
    border-radius: 20px;
    padding: 15px 24px;
    width: 100%;
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
}

.auth-images {
    max-width: 675px;
    width: 100%;
    padding: 64px 40px;
    border-radius: 24px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / cover;
}

.auth-login-box {
    width: 100%;
}

.auth-form {
    max-width: 579px;
    width: 100%;
    padding: 0 24px;
    height: 100%;
}

.auth-images .logo {
    display: flex;
    max-width: 346px;
    height: auto;
    width: 100%;
    margin-bottom: 20px;
}

.auth-images .logo img {
    width: 100%;
    height: auto;
}

.auth-images h1 {
    font-size: 56px;
    line-height: 64px;
    font-weight: 600;
    color: #000214;
    margin-bottom: 20px;
}

.auth-images p {
    font-size: 18px;
    line-height: 28px;
    margin-bottom: 0;
}

.auth-form .icon {
    width: 40px;
    height: 40px;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.auth-form .icon img {
    width: 100%;
    height: auto;
}

.auth-form h2 {
    font-weight: 700;
    font-size: 48px;
    line-height: 48px;
    color: #00033F;
    margin-bottom: 24px;
}

.auth-form-title {
    margin-bottom: 56px;
}

.remeber-forgot-box .forgot-link {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-decoration: underline;
    color: #00033F;
    transition: all 0.3s ease;
}

.remeber-forgot-box .forgot-link:hover {
    color: var(--primary);
}

.auth-form-title p {
    font-size: 18px;
    line-height: 27px;
    margin-bottom: 0;
}

/* Headre Section */

.main-layout {
    min-height: 100dvh;
    overflow-x: hidden;
    max-width: 100vw;
    box-sizing: border-box;
}

.main-header {
    border-bottom: 1px solid var(--border);
}

.logo-header {
    padding: 20px 40px;
    display: flex;
    min-width: 280px;
    max-width: 280px;
    border-right: 1px solid var(--border);
}

.logo-header .logo {
    max-width: 200px;
    height: auto;
    width: 100%;
    display: flex;
}

.logo-header .logo img {
    width: 100%;
    height: auto;
}

.main-header .header-right {
    align-items: center;
    padding: 16px 40px;
}

.profile-dropdown .dropdown-toggle {
    background: transparent;
    border: none;
    box-shadow: none;
    display: flex;
    align-items: center;
    gap: 16px;
}

.profile-dropdown .profile-pic {
    min-width: 44px;
    max-width: 44px;
    height: 44px;
    border-radius: 50%;
}

.profile-dropdown .profile-pic img {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    object-fit: cover;
}

.profile-dropdown .profile-info {
    margin-left: 16px;
}

.profile-dropdown .profile-name {
    font-weight: 600;
    font-size: 14px;
    line-height: 21px;
    margin-bottom: 1px;
    color: #00033F;
    text-align: left;
}

.profile-dropdown .profile-role {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    text-align: left;
}

.profile-dropdown .dropdown-toggle::after {
    content: "\\e903";
    font-family: 'icomoon' !important;
    border: none;
    width: 18px;
    height: 18px;
    color: var(--secondary);
    font-size: 18px;
    list-style: 18px;
}

.profile-dropdown .dropdown-menu {
    padding: 0;
    border: 1px solid var(--border);
    padding: 6px;
    margin-top: 14px !important;
}

.profile-dropdown .dropdown-menu .dropdown-item {
    padding: 8px 12px;
    font-size: 16px;
    line-height: 20px;
    color: var(--secondary);
    border-radius: 6px;
    border: 0;
    transition: all 0.3s ease;
}

.profile-dropdown .dropdown-menu .dropdown-item:hover {
    color: var(--white);
    background: var(--primary);
}

.sidebar {
    min-height: calc(100dvh - 78px);
    min-width: 280px;
    max-width: 280px;
    border-right: 1px solid var(--border);
    padding: 24px 14px;
    display: flex;
    flex-direction: column;
}

.sidebar-menu {
    list-style: none;
    padding: 0;
    margin: 0 0 24px;
}

.sidebar-link,
.sidebar-menu .submenu li a {
    padding: 0;
    list-style: none;
    padding: 15px 24px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    text-decoration: none;
    color: var(--secondary);
    border: 0;
    background: transparent;
    border: 1px solid var(--white);
    transition: all 0.3s ease;
}

.sidebar-link .icon,
.sidebar-menu .submenu li a .icon {
    min-width: 32px;
    max-width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 24px;
    font-size: 30px;
    line-height: 30px;
}

.sidebar-link:hover,
.sidebar-link.active,
.sidebar-menu .submenu li a:hover,
.sidebar-menu .submenu li a.active {
    background: var(--primary);
    color: var(--white);
}

.sidebar-menu .submenu {
    padding-left: 15px;
}

.sidebar-menu .submenu li a {
    padding: 16px;
}

.sidebar-menu .submenu li a .icon {
    margin-right: 20px;
}

.signout-button {
    margin-top: auto;
}

.signout-button .btns {
    max-width: 185px;
    width: 100%;
    margin: 0 auto;
    padding: 11px 23px;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    gap: 10px;
    background: #635EEC;
    border: 1px solid #635EEC;
    box-shadow: 0px 20px 50px 0px #3745571A;
    transition: all 0.3s ease;
}

.signout-button .btns .icon {
    min-width: 32px;
    max-width: 32px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
    line-height: 26px;
}

.signout-button .btns:hover {
    background: var(--white);
    border: 1px solid #635EEC;
    box-shadow: 0px 20px 50px 0px #3745571A;
}

.close-button {
    display: none;
    border: 0;
    padding: 0;
    background: transparent;
    width: fit-content;
    font-size: 16px;
    line-height: 16px;
    color: var(--primary);
    margin-left: auto;
    margin-top: -6px;
    margin-bottom: 6px;
}

.admin-page {
    padding: 24px 40px;
}

.admin-page-title {
    margin-bottom: 24px;
}

.page-section-title {
    font-weight: 600;
    font-size: 30px;
    line-height: 45px;
    color: #00033F;
    margin-bottom: 0;
}

.admin-page-title .btns {
    width: fit-content;
    padding: 11px 23px;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    font-weight: 500;
    gap: 8px;
    text-decoration: unset;
}

.admin-page-title .btns i {
    display: flex;
    font-size: 16px;
    line-height: 16px;
}

.buildings-filter,
.import_filter {
    padding: 24px;
    border: 1px solid var(--border);
    border-radius: 16px;
    gap: 16px;
    margin-bottom: 24px;
}

.buildings-filter .form-control {
    min-height: 48px;
    font-size: 14px;
    list-style: 20px;
    border-radius: 12px;
}

.buildings-filter .form-row {
    max-width: 436px;
    width: 100%;
    gap: 16px;
}

.buildings-filter .form-group {
    width: 100%;
}

.buildings-filter .search-icon {
    position: relative;
}

.buildings-filter .search-icon .form-control {
    padding-left: 56px;
}

.buildings-filter .search-icon i {
    font-size: 22px;
    line-height: 22px;
    color: var(--secondary);
    position: absolute;
    top: 13px;
    left: 24px;
}

.custom-select .css-13cymwt-control,
.custom-select .css-t3ipsp-control,
.custom-select .css-3iigni-container .css-16xfy0z-control {
    background: transparent;
    min-height: 48px;
    border: 1px solid var(--border);
    border-radius: 12px;
    box-shadow: unset !important;
}

.custom-select .css-1jqq78o-placeholder {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.custom-select .css-3iigni-container .css-16xfy0z-control {
    background: #EEEEEE;
}

.custom-select .css-t3ipsp-control:hover {
    border: 1px solid var(--border);
}

.custom-select .css-t3ipsp-control {
    border: 1px solid var(--primary);
}

.custom-select .css-19bb58m {
    font-size: 16px;
    line-height: 20px;
    font-family: 'Poppins';
}

.custom-select .css-1u9des2-indicatorSeparator {
    display: none;
}

.custom-select .css-tj5bde-Svg {
    fill: var(--secondary);
    stroke: var(--secondary);
}

.common-table {
    border: 1px solid var(--border);
    border-radius: 8px;
    overflow: hidden;
}

.common-table .table-wrpper {
    overflow: auto;
}

.common-table table {
    width: 100%;
}

.common-table table thead th {
    background: #E9E9FC;
    padding: 24px 16px;
    font-size: 15px;
    line-height: 23px;
    font-weight: 600;
    white-space: nowrap;
    border-bottom: 1px solid #D5D5D5;
}

.common-table table tbody td {
    padding: 16px;
    font-size: 14px;
    line-height: 21px;
    color: #00033F;
    font-weight: 400;
    vertical-align: middle;
    border-bottom: 1px solid var(--border);
}

.properties-listing .common-table table tbody td {
    border-bottom: 0;
}

.properties-listing .common-table table .period-tr td {
    padding: 12px 16px;
    border-bottom: 1px solid var(--border);
}

.common-table .period-item {
    display: flex;
    align-items: center;
    margin-bottom: 48px;
}

.common-table .period-item:last-child {
    margin-bottom: 0;
}

.common-table .period-item p {
    margin-bottom: 0;
    color: #000214;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    margin-right: 8px;
}

.common-table .period-item ul {
    list-style: none;
    padding: 0;
    gap: 12px;
    margin-bottom: 0;
}

.common-table .period-item ul li {
    padding: 4px 8px;
    background: #E9E9FC;
    border-radius: 8px;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #000214;
    gap: 12px;
    display: flex;
    align-items: center;
}

.common-table .period-item ul li span {
    white-space: nowrap;
}

.common-table .status {
    display: flex;
    width: fit-content;
    padding: 2px 14px;
    background: #00AC34;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    border-radius: 50px;
    color: var(--white);
    margin-bottom: 0;
}

/* Client 2026-09-11: three property statuses. The base rule above was hardcoded
   green with no modifier, so every badge looked Active whatever the value. Green
   stays Active; Inactive is neutral grey (kept for reference, nothing to act on)
   and Training amber, so a sandbox copy is obvious at a glance. Both are excluded
   from the Dashboard totals. */
.common-table .status.active {
    background: #00AC34;
}

.common-table .status.inactive {
    background: #6B7280;
}

.common-table .status.training {
    background: #D97706;
}

/* Rows-per-page selector on the Properties Listing (client 2026-09-15: "display
   more than 10 lines … we can go for 100"). Sized down from the full .form-control
   so it sits on the pagination line instead of dominating it. */
.pagination-info .rows-per-page {
    white-space: nowrap;
    color: var(--secondary);
}

.pagination-info .rows-per-page .form-control {
    width: auto;
    min-height: 34px;
    padding: 0 10px;
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
}

/* Status is editable straight from the listing (client 2026-09-11). The <select>
   keeps the pill look of the badge it replaces — same radius, same colour per
   state — so the column still reads as a status at a glance rather than as a form
   control. appearance:none drops the native chrome; the caret is drawn as an
   inline SVG background so it stays white on every colour. */
.common-table .status-select {
    /* The badge rule this inherits sets display:flex, which browsers handle
       inconsistently on a <select> — pin it back to inline-block. */
    display: inline-block;
    line-height: 21px;
    appearance: none;
    border: none;
    padding: 2px 30px 2px 14px;
    cursor: pointer;
    font-family: inherit;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-position: right 12px center;
}

.common-table .status-select:focus-visible {
    outline: 2px solid var(--primary);
    outline-offset: 2px;
}

.common-table .status-select:disabled {
    opacity: 0.6;
    cursor: progress;
}

/* The dropdown list itself is drawn by the OS, so its options need readable
   colours rather than white-on-white. */
.common-table .status-select option {
    background: var(--white);
    color: var(--secondary);
}

/* Sortable column headers on the Properties Listing. The arrow is always present
   (dimmed until the column is the active sort) so the header does not jump width
   when the user clicks it. */
.common-table th.sortable-th {
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    white-space: nowrap;
    transition: color 0.2s ease;
}

.common-table th.sortable-th:hover {
    color: var(--primary);
}

.common-table th.sortable-th .sort-arrow {
    margin-left: 6px;
    font-size: 11px;
    opacity: 0.35;
}

.common-table th.sortable-th.sorted {
    color: var(--primary);
}

.common-table th.sortable-th.sorted .sort-arrow {
    opacity: 1;
}

.common-table .button-group {
    display: flex;
    align-items: center;
    gap: 10px;
}

.common-table .button-group .btns-table,
.period-table .btns-table {
    border: 1px solid #E9E9FC;
    background: #E9E9FC;
    border-radius: 8px;
    padding: 7px 15px;
    text-decoration: unset;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    color: #635EEC;
    transition: all 0.3s ease-in-out;
}

.common-table .button-group .btns-table i,
.period-table .btns-table i {
    display: flex;
    font-size: 16px;
    line-height: 16px;
}


.common-table .button-group .btns-table.edit-btn {
    background: #D9FFFA;
    color: #00AC34;
    border: 1px solid #D9FFFA;
}

.common-table .button-group .btns-table.delete-btn {
    background: #FFE7E7;
    color: #DC3545;
    border: 1px solid #FFE7E7;
}

.common-table .button-group .btns-table.duplicate-btn {
    background: #20c997;
    color: #ffffff;
    border: 1px solid #20c997;
}

.common-table .button-group .btns-table:hover,
.common-table .button-group .btns-table.edit-btn:hover,
.period-table .btns-table:hover {
    background: var(--primary);
    color: var(--white);
    border: 1px solid var(--primary);
}

.common-table .button-group .btns-table.edit-btn:hover {
    color: var(--white);
    background: #00AC34;
    border: 1px solid #00AC34;
}

.common-table .button-group .btns-table.delete-btn:hover {
    color: var(--white);
    background: #DC3545;
    border: 1px solid #DC3545;
}

.common-table .button-group .btns-table.duplicate-btn:hover {
    color: var(--white);
    background: #17a2b8;
    border: 1px solid #17a2b8;
}

/* Cost Fields Section Styling */
.cost-fields-section {
    margin-top: 20px;
}

.cost-field-group {
    background: #f8f9fa;
    border: 1px solid #e9ecef !important;
    border-radius: 8px;
}

.cost-field-group h6 {
    color: var(--primary);
    font-weight: 600;
    margin-bottom: 15px;
}

.cost-field-group .form-group label {
    font-weight: 500;
    color: #495057;
    margin-bottom: 8px;
}

.common-table .button-group .remove-btn {
    background: #FFDCD9;
    border: 1px solid #FFDCD9;
    color: #EF3826;
}

.common-table .button-group .remove-btn:hover {
    color: var(--white);
    background: #EF3826;
    border: 1px solid #EF3826;
}

.common-table table tr:last-child td {
    border: 0;
}

.properties-listing .page-section-title {
    margin-bottom: 24px;
}

.back-title {
    margin-bottom: 24px;
}

.back-btn-title {
    background: transparent;
    border: 0;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--secondary);
    padding: 0;
    margin-right: 8px;
    font-size: 20px;
    line-height: 20px;
    transition: all 0.3s ease-in-out;
}

.back-btn-title:hover {
    color: var(--primary);
}

.create-building-form {
    max-width: 824px;
    width: 100%;
}

/* Client 2026-09-09: "Can we set create/edit building page in full width like
   create/edit key page". The key page is full width because its own
   \`.create-key-form-box { max-width: 824px }\` rule is commented out.
   The same cannot simply be deleted here: \`.create-building-form\` is shared by FOUR
   pages — Create/Edit Building, Add/Edit Team, Import Data and the unused
   CreateBuilding-only-create — and only the building page was asked about. So the cap
   is lifted through a modifier the building form opts into, leaving the other pages
   exactly as they are. Add \`form-full-width\` alongside the base class to widen another
   page later. */
.create-building-form.form-full-width {
    max-width: none;
}

.create-building-form .form-group label {
    color: #000214;
}

.create-building-form .form-control {
    background: var(--white);
    min-height: 48px;
}

.create-building-form textarea.form-control,
textarea.form-control {
    min-height: 100px;
    padding: 16px;
}

.create-building-form .custom-select .css-13cymwt-control,
.create-building-form .custom-select .css-t3ipsp-control {
    background: var(--white);
}

.create-building-form .button-group {
    display: flex;
    gap: 32px;
}

.create-building-form .button-group .btns {
    width: fit-content;
    min-width: 182px;
    padding: 11px 24px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    border-radius: 12px;
}

.create-building-form .button-group .btns.cancel-btns {
    border: 1px solid #EF3826;
    color: #EF3826;
    background: transparent;
}

.create-building-form .button-group .btns.cancel-btns:hover {
    color: var(--white);
    background: #EF3826;
}

.date-picker .react-datepicker-wrapper {
    width: 100%;
}

.date-picker {
    position: relative;
}

.date-picker .form-control {
    padding-right: 40px;
}

.date-picker .icon {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    line-height: 22px;
    color: var(--secondary);
    position: absolute;
    top: 11px;
    right: 16px;
    pointer-events: none;
}

.bar-button {
    width: 32px;
    height: 32px;
    font-size: 20px;
    line-height: 20px;
    display: none;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: 0;
    padding: 0;
}

.border-btns-copy {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #635EEC;
    color: #635EEC;
    font-size: 16px;
    line-height: 24px;
    padding: 7px 15px;
    font-weight: 500;
    border-radius: 8px;
    background: transparent;
    text-decoration: unset;
    gap: 8px;
    transition: all 0.3s ease-in-out;
}

.border-btns-copy i {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    font-size: 20px;
    line-height: 20px;
}

.border-btns-copy:hover {
    background: #635EEC;
    color: var(--white);
}

.build-details-wrapper {
    margin-bottom: 40px;
}

.build-box-title {
    color: #000214;
    font-size: 24px;
    line-height: 32px;
    font-weight: 600;
    margin-bottom: 16px;
}

.build-details-card {
    padding: 24px;
    background: var(--white);
    box-shadow: 2px 2px 20px 0px #0000000A;
    border-radius: 16px;
}

.build-details-card ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.build-details-card li:not(:last-child) {
    margin-bottom: 24px;
}

.build-details-card li label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 8px;
    font-weight: 500;
}

.build-details-card li p {
    color: #000214;
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
    margin-bottom: 0;
}

.build-details-card.build-full-active {
    padding-right: 150px;
    position: relative;
}

.build-details-card.build-full-active .row {
    --bs-gutter-y: 24px;
}

.build-full-active .status {
    padding: 4px 24px;
    background: #00AC34;
    color: var(--white);
    width: fit-content;
    margin: 0;
    border-radius: 50px;
    position: absolute;
    top: 24px;
    right: 24px;
    font-size: 16px;
    line-height: 24px;
}

.period-box-title {
    margin-bottom: 24px;
}

.period-box-title .period-date {
    background: #E9E9FC;
    padding: 4px 8px;
    border-radius: 8px;
    display: flex;
    gap: 12px;
    color: #000214;
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
}

.period-box-title .period-date p {
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
    color: #000214;
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
}

.period-box-title .period-date p i {
    min-width: 20px;
    max-width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--secondary);
    font-size: 18px;
    line-height: 18px;
}

.period-table {
    overflow-x: auto;
}

.period-table table {
    width: 100%;
}

.period-table thead th {
    font-size: 18px;
    line-height: 24px;
    color: var(--secondary);
    font-weight: 500;
    padding: 0 12px 19px;
    white-space: nowrap;
}

.period-table tbody td {
    font-size: 16px;
    line-height: 24px;
    color: #000214;
    font-weight: 500;
    padding: 19px 12px;
    vertical-align: middle;
}

.period-table tbody td:first-child,
.period-table thead th:first-child {
    padding-left: 0;
}

.period-table tbody td:last-child,
.period-table thead th:last-child {
    padding-right: 0;
}

.period-table .btns-table {
    width: fit-content;
    margin-left: auto;
}

.period-table tbody tr:last-child td {
    padding-bottom: 0;
}

.table-pagination {
    font-size: 14px;
    line-height: 21px;
    color: #656671;
    font-weight: 500;
}

.pagination-controls {
    border: 1px solid #D5D5D5;
    border-radius: 8px;
    min-width: 86px;
}

.pagination-controls .btns-table {
    border: 0;
    padding: 0;
    flex: 1 1;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px 10px;
    color: #000214;
    transition: all 0.3s ease-in-out;
}

.pagination-controls .btns-table.next-btn {
    border-left: 1px solid #D5D5D5;
}

.pagination-controls .btns-table:disabled {
    cursor: not-allowed;
    opacity: 0.6;
}

.pagination-controls .btns-table i {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    line-height: 12px;
}

.pagination-controls .btns-table:hover {
    color: var(--primary);
}

.period-list .period-item {
    margin-bottom: 48px;
}

.period-list .period-item:last-child {
    margin-bottom: 0;
}

/* Period actions on building details should match table action buttons */
.period-box-title .button-group {
    display: flex;
    align-items: center;
    gap: 10px;
}

.period-box-title .button-group .btns-table {
    border: 1px solid #E9E9FC;
    background: #E9E9FC;
    border-radius: 8px;
    padding: 7px 15px;
    text-decoration: unset;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    color: #635EEC;
    transition: all 0.3s ease-in-out;
}

.period-box-title .button-group .btns-table i {
    display: flex;
    font-size: 16px;
    line-height: 16px;
}

.period-box-title .button-group .btns-table.edit-btn {
    background: #D9FFFA;
    color: #00AC34;
    border: 1px solid #D9FFFA;
}

.period-box-title .button-group .btns-table.delete-btn {
    background: #FFE7E7;
    color: #DC3545;
    border: 1px solid #FFE7E7;
}

.period-box-title .button-group .btns-table:hover {
    background: var(--primary);
    color: var(--white);
    border: 1px solid var(--primary);
}

.period-box-title .button-group .btns-table.edit-btn:hover {
    color: var(--white);
    background: #00AC34;
    border: 1px solid #00AC34;
}

.period-box-title .button-group .btns-table.delete-btn:hover {
    color: var(--white);
    background: #DC3545;
    border: 1px solid #DC3545;
}

/* Copy mode indicator for building edit page */
.period-copy-badge {
    margin-left: 12px;
    padding: 4px 12px;
    border-radius: 999px;
    font-size: 13px;
    line-height: 18px;
    font-weight: 500;
    background: #E9E9FC;
    color: #635EEC;
}

.btn-text {
    background: transparent;
    border: 0;
    font-size: 14px;
    line-height: 20px;
    color: var(--primary);
    font-weight: 600;
    gap: 4px;
    padding: 0;
    transition: all 0.3s ease-in-out;
}

.btn-text .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 14px;
}

.btn-text:hover {
    color: var(--secondary);
}

.managing-input {
    margin-top: 14px;
}

.remove-btn {
    color: #EF3826;
}

.remove-btn:hover {
    color: var(--primary);
}

.remove-btn .icon {
    font-size: 12px;
    line-height: 12px;
}

.managing-input .remove-btn {
    width: fit-content;
    margin-left: auto;
}

.access-level-check {
    display: flex;
}

.access-level-check .form-check-label span {
    padding-left: 32px;
}

.access-level-check .form-check-label span::before {
    width: 20px;
    height: 20px;
    font-size: 12px;
    line-height: 12px;
    font-weight: 600;
}

.import-data-page .page-section-title {
    margin-bottom: 24px;
}

.import-data-page .create-building-form {
    max-width: 100%;
    margin-bottom: 40px;
    border: 1px solid #6534401A;
    background: var(--white);
}

.import_filter .row {
    --bs-gutter-y: 24px;
}

.radio_list_import {
    gap: 24px;
    margin-bottom: 24px;
}

.radio_list_import label {
    display: flex;
    position: relative;
}

.radio_list_import label input {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    opacity: 0;
}

.radio_list_import label span {
    display: flex;
    min-width: 275px;
    background: var(--white);
    align-items: center;
    justify-content: center;
    color: #00033F;
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
    padding: 15px 20px;
    cursor: pointer;
    border: 1px solid #635EEC;
    border-radius: 12px;
    transition: all 0.3s ease-in-out;
}

.radio_list_import label input:checked~span {
    background: var(--primary);
    color: var(--white);
}

.uploaded-surface-section .inner-title {
    font-size: 18px;
    line-height: 27px;
    color: #000214;
    font-weight: 500;
    margin-bottom: 24px;
}

.uploaded-area-box .dropzone-box {
    min-height: 240px;
    border: 2px dashed var(--secondary);
    display: flex;
    padding: 16px;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
}

.uploaded-area-box .dropzone-content {
    max-width: 261px;
    width: 100%;
    margin: 0 auto;
}

.uploaded-area-box .dropzone-content .icon {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 7px;
    font-size: 32px;
    line-height: 32px;
    color: var(--secondary);
}

.uploaded-area-box .dropzone-content p {
    text-align: center;
    font-size: 18px;
    line-height: 27px;
    color: var(--secondary);
    margin-bottom: 0;
}

.uploaded-surface-box {
    width: 100%;
    padding: 24px;
    background: var(--white);
    border-radius: 12px;
}

.uploaded-surface-box .inner-title {
    margin-bottom: 20px;
}

.uploaded-surface-item {
    padding: 16px 53px 16px 24px;
    background: #E9E9FC;
    border-radius: 12px;
    position: relative;
    margin-bottom: 12px;
}

.uploaded-surface-item:last-child {
    margin-bottom: 12px;
}

.uploaded-surface-item .title-icon {
    width: 100%;
}

.uploaded-surface-item .title-icon .icon {
    min-width: 24px;
    max-width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    line-height: 24px;
    color: #0F172A;
    margin-right: 10px;
}

.uploaded-surface-item .title-icon p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    max-width: 100%;
    font-size: 14px;
    line-height: 21px;
    font-weight: 400;
    color: var(--secondary);
}

.uploaded-surface-item .remove-btn {
    width: 16px;
    height: 16px;
    background: transparent;
    border: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    line-height: 12px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 24px;
}

.import-step-date {
    gap: 350px;
    margin-bottom: 24px;
}

.import-step-date .step {
    min-width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--border);
    color: var(--primary);
    position: relative;
    border-radius: 12px;
    font-size: 24px;
    line-height: 36px;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
}

.import-step-date .step::before {
    content: '';
    width: 340px;
    height: 2px;
    background: var(--border);
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -345px;
    pointer-events: none;
    border-radius: 2px;
}

.import-step-date .step:first-child:before {
    display: none;
}

.import-step-date .step.active::before {
    background: var(--primary);
}

.import-step-date .step.active,
.import-step-date .step:hover {
    border: 1px solid var(--primary);
}

.import-step-date .step.previous {
    background: var(--primary);
    color: var(--white);
    border: 1px solid var(--primary);
}

/* Imported Data List Styles */
.imported-data-page {
    padding: 20px;
}

.imported-inline-edit-input {
    width: 100%;
    min-width: 110px;
    padding: 6px 8px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background: #fff;
    font-size: 0.9rem;
}

.imported-inline-edit-input:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.imported-data-summary {
    background: #f8f9fa;
    padding: 15px;
    border-radius: 8px;
    margin-bottom: 20px;
    display: flex;
    gap: 30px;
}

.imported-data-summary p {
    margin: 0;
    font-weight: 600;
    color: #495057;
}

.building-group {
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    margin-bottom: 20px;
    overflow: hidden;
}

.building-header {
    background: var(--primary);
    color: white;
    padding: 15px 20px;
}

.building-header h3 {
    margin: 0 0 5px 0;
    font-size: 1.2rem;
}

.building-info {
    display: flex;
    gap: 20px;
    font-size: 0.9rem;
}

.building-info span {
    opacity: 0.9;
}

.period-group {
    border-bottom: 1px solid #e9ecef;
}

.period-group:last-child {
    border-bottom: none;
}

.period-header {
    background: #f8f9fa;
    padding: 12px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e9ecef;
}

.period-header h4 {
    margin: 0;
    font-size: 1rem;
    color: #495057;
    flex-grow: 1;
}

.record-count {
    background: #6c757d;
    color: white;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 0.8rem;
}

.records-list {
    padding: 0;
}

.record-item {
    padding: 15px 20px;
    border-bottom: 1px solid #f1f3f4;
}

.record-item:last-child {
    border-bottom: none;
}

.record-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.record-id {
    font-weight: 600;
    color: var(--primary);
}

.record-date {
    color: #6c757d;
    font-size: 0.9rem;
}

.record-details {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 10px;
}

.detail-item {
    font-size: 0.9rem;
}

.detail-item strong {
    color: #495057;
    display: block;
    margin-bottom: 2px;
}

.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    margin-top: 30px;
    padding: 20px;
}

.page-info {
    font-weight: 600;
    color: #495057;
}

.no-data {
    text-align: center;
    padding: 60px 20px;
    color: #6c757d;
}

.no-data p {
    font-size: 16px;
    margin: 0;
}

.multi-custom-select .costs-select__multi-value,
.multi-custom-select .costs-select__clear-indicator {
    display: none;
}

.multi-custom-option {
    padding: 0;
    margin-bottom: 0;
}

.multi-custom-option li {
    padding: 6px 12px;
    background: var(--secondary);
    border-radius: 4px;
    color: var(--white);
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    gap: 4px;
}

.multi-custom-option li span {
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    line-height: 12px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
}

/* .create-key-form-box {
    max-width: 824px;
    width: 100%;
} */

.key-card {
    padding: 24px;
    box-shadow: 4px 4px 40px 0px #0000000A;
    border-radius: 16px;
}

.calculation-label {
    margin-bottom: 14px;
}

.calculation-label .arrow-btn {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--primary);
    background: var(--primary);
    font-size: 14px;
    line-height: 14px;
    color: var(--white);
    border-radius: 4px;
    transition: all 0.3s ease-in-out;
}

.calculation-label .arrow-btn:hover {
    background: var(--white);
    color: var(--primary);
}

.variable-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 11px;
    border-radius: 4px;
    background: var(--secondary);
    font-size: 16px;
    line-height: 20px;
    font-weight: 400 !important;
    color: var(--white);
    cursor: pointer;
    border: 1px solid var(--secondary) !important;
    transition: all 0.3s ease-in-out;
}

.variable-btn:hover {
    color: var(--secondary);
    background: var(--white);
}

.operator-btn {
    padding: 0;
    width: 32px;
    height: 32px;
    border: 1px solid var(--secondary);
    border-radius: 4px;
    font-size: 16px;
    line-height: 20px;
    color: var(--primary);
    transition: all 0.3s ease-in-out;
}

.operator-btn:hover {
    background: var(--primary);
    color: var(--white);
    border: 1px solid var(--primary);
}

.form-radio-label span::before {
    width: 20px;
    height: 20px;
    border: 2px solid var(--primary);
    border-radius: 50%;
}

.form-radio-label span {
    padding-left: 30px;
    font-size: 16px;
    line-height: 20px;
    color: #000214;
    font-weight: 500;
}

.form-radio-label span::after {
    content: '';
    width: 12px;
    height: 12px;
    background: var(--primary);
    border-radius: 50%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 4px;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease-in-out;
}

.form-radio-label input:checked~span::before {
    background: transparent;
}

.form-radio-label input:checked~span::after {
    opacity: 1;
    visibility: visible;
}

.create-key-form-box .form-group label {
    color: #000214;
}

.create-key-form-box .form-group label span {
    font-size: 14px;
    line-height: 20px;
    color: var(--secondary);
    font-weight: 400;
}

.destination-title h6 {
    margin-bottom: 0;
    font-size: 20px;
    line-height: 24px;
    color: #000214;
    font-weight: 600;
}

.destination-title .add-more-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: 0;
    gap: 8px;
    font-size: 16px;
    line-height: 16px;
    color: var(--primary);
    padding: 0;
    transition: all 0.3s ease-in-out;
}

.destination-title .add-more-btn:hover {
    color: var(--black);
}

.destination-title .add-more-btn i {
    display: flex;
    font-size: 14px;
    line-height: 14px;
}

/* Building and Period Sections */
.building-section {
    margin-bottom: 40px;
}

.period-section {
    margin-bottom: 30px;
}

.section-header {
    background: var(--primary);
    color: white;
    padding: 15px 20px;
    margin: 0 0 20px 0;
    border-radius: 8px;
    font-size: 1.2rem;
    font-weight: 600;
}

/* Create Key specific styles */
.btn-danger.btn-sm {
    background: #dc3545;
    border-color: #dc3545;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    border: 1px solid #dc3545;
}

.btn-danger.btn-sm:hover {
    background: #c82333;
    border-color: #bd2130;
}

.arrow-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.create-key-form-box .form-control {
    min-height: 48px;
}

.create-key-form-box .form-group label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.destination-key-card .row {
    --bs-gutter-y: 24px;
}

/* Dashboard Page */
.dashboard-page .dashboard-header {
    margin-bottom: 32px;
}

.dashboard-page .dashboard-subtitle {
    font-size: 16px;
    line-height: 24px;
    color: var(--secondary);
    margin-bottom: 0;
    margin-top: 6px;
}

/* Stat Cards */
.stat-card {
    background: var(--white);
    border-radius: 16px;
    border: 1px solid var(--border);
    padding: 20px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    box-shadow: 2px 2px 20px 0px #0000000A;
    transition: box-shadow 0.3s ease;
}

.stat-card:hover {
    box-shadow: 2px 4px 28px 0px #0000001A;
}

.stat-card-body {
    display: flex;
    flex-direction: column;
    gap: 4px;
    border-left: 3px solid var(--secondary);
    padding-left: 16px;
}

.stat-label {
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    color: var(--secondary);
    margin-bottom: 0;
}

.stat-value {
    font-size: 40px;
    line-height: 48px;
    font-weight: 700;
    color: #00033F;
    margin-bottom: 0;
    letter-spacing: -0.5px;
}

.stat-icon-circle {
    min-width: 44px;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: var(--secondary);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--white);
    font-size: 20px;
    line-height: 20px;
    flex-shrink: 0;
}

/* Quick Actions */
.quick-actions-section {
    margin-top: 8px;
}

.quick-actions-title {
    font-size: 22px;
    line-height: 32px;
    font-weight: 600;
    color: #00033F;
    margin-bottom: 24px;
}

.quick-action-card {
    display: flex;
    flex-direction: column;
    padding: 28px 24px;
    background: var(--white);
    border: 1px solid var(--border);
    border-radius: 16px;
    text-decoration: none;
    color: inherit;
    box-shadow: 2px 2px 20px 0px #0000000A;
    transition: all 0.3s ease;
    height: 100%;
}

.quick-action-card:hover {
    border-color: var(--primary);
    box-shadow: 2px 4px 28px 0px #1B13E31A;
    color: inherit;
}

.quick-action-icon {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: var(--secondary);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--white);
    font-size: 20px;
    line-height: 20px;
    margin-bottom: 20px;
}

.quick-action-label {
    font-size: 18px;
    line-height: 26px;
    font-weight: 600;
    color: var(--secondary);
    margin-bottom: 6px;
}

.quick-action-desc {
    font-size: 14px;
    line-height: 21px;
    color: var(--secondary);
    margin-bottom: 0;
}

/* ─── My Account Pages ─────────────────────────────────── */
.my-account-header {
    margin-bottom: 32px;
}

.my-account-subtitle {
    font-size: 16px;
    line-height: 24px;
    color: var(--secondary);
    margin-top: 4px;
    margin-bottom: 0;
}

.my-account-form {
    max-width: 824px;
    width: 100%;
}

/* Profile photo */
.profile-photo-wrapper {
    margin-bottom: 32px;
}

.profile-photo-circle {
    position: relative;
    width: 110px;
    height: 110px;
    border-radius: 50%;
    overflow: visible;
}

.profile-photo-img {
    width: 110px;
    height: 110px;
    border-radius: 50%;
    object-fit: cover;
    display: block;
}

.profile-photo-edit-btn {
    position: absolute;
    bottom: 4px;
    right: 4px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: var(--secondary);
    border: 2px solid #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 14px;
    line-height: 1;
    cursor: pointer;
    transition: background 0.2s ease;
    padding: 0;
}

.profile-photo-edit-btn:hover {
    background: var(--primary);
}

.my-account-save-btn {
    min-width: 182px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    border-radius: 12px;
    padding: 11px 24px;
}

.my-account-form .form-group label {
    color: #000214;
}

.my-account-form .form-control {
    background: #fff;
    min-height: 55px;
}

.my-account-form .form-control[readonly] {
    background: #f5f6f8;
    cursor: default;
}

.profile-photo-uploading {
    position: absolute;
    inset: 0;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
}

/* White Labelling toggle */
.toggle-switch {
    width: 48px;
    height: 26px;
    background: #ccc;
    border-radius: 13px;
    position: relative;
    cursor: pointer;
    transition: background 0.2s;
    flex-shrink: 0;
    -webkit-user-select: none;
            user-select: none;
}
.toggle-switch.active {
    background: #4caf50;
}
.toggle-knob {
    position: absolute;
    top: 3px;
    left: 3px;
    width: 20px;
    height: 20px;
    background: #fff;
    border-radius: 50%;
    transition: left 0.2s;
    box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}
.toggle-switch.active .toggle-knob {
    left: 25px;
}
.logo-preview img {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 4px;
    background: #fff;
}
/* Logo upload dropzone */
.logo-upload-dropzone {
  border: 2px dashed #c7c9e3;
  border-radius: 10px;
  padding: 24px 16px;
  text-align: center;
  cursor: pointer;
  background: #f8f9ff;
  transition: border-color 0.2s, background 0.2s;
  -webkit-user-select: none;
          user-select: none;
}
.logo-upload-dropzone:hover {
  border-color: #5b5fcf;
  background: #f0f1ff;
}
.logo-upload-icon {
  margin-bottom: 8px;
}
.logo-upload-text {
  font-size: 14px;
  color: #555;
}
.logo-upload-hint {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;IACnC,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;;;4CAG4C;AAC5C;IACI,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,+BAA+B;IAC/B,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;IACpC,kBAAkB;IAClB,QAAQ;IACR,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,2BAA2B;IAC3B,wBAAwB;IACxB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA,cAAc;AACd;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,4EAAkE;AACtE;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,mBAAmB;;AAEnB;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,+BAA+B;IAC/B,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAgB;IAChB,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;AACpB;;AAEA;;IAEI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;IACvB,SAAS;IACT,uBAAuB;IACvB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;;IAEI,eAAe;IACf,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;;;;IAII,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,yBAAyB;IACzB,uCAAuC;IACvC,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,QAAQ;IACR,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,+BAA+B;IAC/B,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;;;IAGI,uBAAuB;IACvB,gBAAgB;IAChB,+BAA+B;IAC/B,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;;;+BAI+B;AAC/B;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;gEAEgE;AAChE;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;;;;6DAI6D;AAC7D;IACI;oEACgE;IAChE,qBAAqB;IACrB,iBAAiB;IAGjB,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,oBAAoB;IACpB,yDAAsR;IACtR,4BAA4B;IAC5B,sCAAsC;AAC1C;;AAEA;IACI,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;wCACwC;AACxC;IACI,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;;6BAE6B;AAC7B;IACI,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;;IAEI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,cAAc;IACd,gCAAgC;AACpC;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,iBAAiB;AACrB;;;AAGA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,0BAA0B;IAC1B,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA,gCAAgC;AAChC;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;;;;;;;;gBAQgB;AAChB;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;;IAEI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;IACR,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,SAAO;IACP,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,yEAAyE;AACzE;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA,+CAA+C;AAC/C;IACI,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,QAAQ;IACR,UAAU;IACV,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mCAAmC;IACnC,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;IAC/B,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA,8BAA8B;AAC9B;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,SAAS;AACb;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,gCAAgC;AACpC;;AAEA;;;GAGG;;AAEH;IACI,aAAa;IACb,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,6CAA6C;IAC7C,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;IACT,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,UAAU;IACV,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;AACrB;;AAEA,iCAAiC;AACjC;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,+BAA+B;AAC/B;IACI,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;AACnB;;AAEA,eAAe;AACf;IACI,wBAAwB;IACxB,mBAAmB;IACnB,+BAA+B;IAC/B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,sCAAsC;IACtC,gCAAgC;AACpC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,wBAAwB;IACxB,+BAA+B;IAC/B,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,sCAAsC;IACtC,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA,6DAA6D;AAC7D;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,cAAc;IACd,eAAe;IACf,gCAAgC;IAChC,UAAU;AACd;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA,2BAA2B;AAC3B;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,qCAAqC;AACzC;AACA;IACI,UAAU;AACd;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;AACpB;AACA,yBAAyB;AACzB;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,8CAA8C;EAC9C,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB","sourcesContent":[":root {\n    --white: #FFFFFF;\n    --black: #000000;\n    --primary: #1B13E3;\n    --secondary: #48537B;\n    --border: #DEE1E4;\n}\n\nbody {\n    font-family: 'Poppins';\n    color: var(--secondary);\n    font-size: 16px;\n    line-height: 24px;\n    font-weight: 400;\n    overflow-x: hidden;\n    /* Prevent horizontal page scroll */\n    background: #FCFCFC;\n}\n\nhtml {\n    overflow-x: hidden;\n    /* Prevent horizontal page scroll */\n    max-width: 100vw;\n    box-sizing: border-box;\n}\n\n*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n\n.btns {\n    background: var(--primary);\n    padding: 11px 24px;\n    font-size: 16px;\n    line-height: 24px;\n    font-weight: 500;\n    color: var(--white);\n    border: 1px solid var(--primary);\n    min-width: 200px;\n    text-align: center;\n    border-radius: 12px;\n    transition: all 0.3s ease;\n}\n\n.btns:hover {\n    color: var(--primary);\n    background: var(--white);\n}\n\n/* Secondary/cancel button. Mirrors .btns geometry exactly so a Cancel + confirm\n   pair in a modal footer reads as one control group, but outlined instead of\n   filled. Narrower min-width because a cancel action should not carry the same\n   visual weight as the action it cancels. */\n.btns-cancel {\n    background: var(--white);\n    padding: 11px 24px;\n    font-size: 16px;\n    line-height: 24px;\n    font-weight: 500;\n    color: var(--secondary);\n    border: 1px solid var(--border);\n    min-width: 120px;\n    text-align: center;\n    border-radius: 12px;\n    transition: all 0.3s ease;\n}\n\n.btns-cancel:hover {\n    color: var(--primary);\n    border-color: var(--primary);\n    background: var(--white);\n}\n\n.form-group {\n    margin-bottom: 24px;\n}\n\n.form-group label {\n    display: block;\n    font-size: 16px;\n    line-height: 20px;\n    font-weight: 500;\n    color: var(--secondary);\n    margin-bottom: 14px;\n}\n\n.form-control {\n    width: 100%;\n    padding: 0 16px;\n    border: 1px solid #D1D5DB;\n    border-radius: 12px;\n    font-size: 16px;\n    line-height: 20px;\n    font-weight: 400;\n    min-height: 55px;\n    color: var(--secondary);\n    border: 1px solid var(--border);\n    box-shadow: 0px 2px 0px 0px #E7EBEE33 inset;\n    background: #FCFCFC;\n}\n\n.form-control:focus {\n    box-shadow: unset;\n    border: 1px solid var(--primary);\n}\n\n.form-group .password-input {\n    position: relative;\n}\n\n.form-group .password-input .form-control {\n    padding-right: 60px;\n}\n\n.form-group .password-input .icon-btn {\n    width: 54px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-left: 1px solid var(--border);\n    position: absolute;\n    top: 7px;\n    right: 0;\n}\n\n.form-group .password-input .icon-btn i {\n    font-size: 20px;\n    line-height: 20px;\n    color: var(--secondary);\n    cursor: pointer;\n}\n\n.remeber-forgot-box {\n    margin-bottom: 40px;\n}\n\n.form-check-label {\n    position: relative;\n    display: block;\n}\n\n.form-check-label input {\n    position: absolute;\n    top: -100%;\n    left: 0;\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n.form-check-label span {\n    position: relative;\n    padding-left: 24px;\n    display: block;\n    font-size: 16px;\n    line-height: 20px;\n    color: var(--secondary);\n    cursor: pointer;\n}\n\n.form-check-label span::before {\n    content: '\\e902';\n    width: 16px;\n    height: 16px;\n    border: 1px solid var(--border);\n    font-family: 'icomoon' !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n    position: absolute;\n    font-size: 8px;\n    line-height: 8px;\n    font-weight: 900;\n    color: transparent;\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n    background: var(--white);\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.form-check-label input:checked~span::before {\n    color: var(--white);\n    background: var(--primary);\n    border: 1px solid var(--primary);\n}\n\n/* Auth Page */\n.auth-page {\n    padding: 24px 0 24px 24px;\n    min-height: 100dvh;\n    display: flex;\n}\n\n.auth-page .btns {\n    border-radius: 20px;\n    padding: 15px 24px;\n    width: 100%;\n    font-size: 20px;\n    line-height: 28px;\n    font-weight: 600;\n}\n\n.auth-images {\n    max-width: 675px;\n    width: 100%;\n    padding: 64px 40px;\n    border-radius: 24px;\n    background: url('../images/login-bg.png') no-repeat center / cover;\n}\n\n.auth-login-box {\n    width: 100%;\n}\n\n.auth-form {\n    max-width: 579px;\n    width: 100%;\n    padding: 0 24px;\n    height: 100%;\n}\n\n.auth-images .logo {\n    display: flex;\n    max-width: 346px;\n    height: auto;\n    width: 100%;\n    margin-bottom: 20px;\n}\n\n.auth-images .logo img {\n    width: 100%;\n    height: auto;\n}\n\n.auth-images h1 {\n    font-size: 56px;\n    line-height: 64px;\n    font-weight: 600;\n    color: #000214;\n    margin-bottom: 20px;\n}\n\n.auth-images p {\n    font-size: 18px;\n    line-height: 28px;\n    margin-bottom: 0;\n}\n\n.auth-form .icon {\n    width: 40px;\n    height: 40px;\n    margin-bottom: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.auth-form .icon img {\n    width: 100%;\n    height: auto;\n}\n\n.auth-form h2 {\n    font-weight: 700;\n    font-size: 48px;\n    line-height: 48px;\n    color: #00033F;\n    margin-bottom: 24px;\n}\n\n.auth-form-title {\n    margin-bottom: 56px;\n}\n\n.remeber-forgot-box .forgot-link {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    text-decoration: underline;\n    color: #00033F;\n    transition: all 0.3s ease;\n}\n\n.remeber-forgot-box .forgot-link:hover {\n    color: var(--primary);\n}\n\n.auth-form-title p {\n    font-size: 18px;\n    line-height: 27px;\n    margin-bottom: 0;\n}\n\n/* Headre Section */\n\n.main-layout {\n    min-height: 100dvh;\n    overflow-x: hidden;\n    max-width: 100vw;\n    box-sizing: border-box;\n}\n\n.main-header {\n    border-bottom: 1px solid var(--border);\n}\n\n.logo-header {\n    padding: 20px 40px;\n    display: flex;\n    min-width: 280px;\n    max-width: 280px;\n    border-right: 1px solid var(--border);\n}\n\n.logo-header .logo {\n    max-width: 200px;\n    height: auto;\n    width: 100%;\n    display: flex;\n}\n\n.logo-header .logo img {\n    width: 100%;\n    height: auto;\n}\n\n.main-header .header-right {\n    align-items: center;\n    padding: 16px 40px;\n}\n\n.profile-dropdown .dropdown-toggle {\n    background: transparent;\n    border: none;\n    box-shadow: none;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.profile-dropdown .profile-pic {\n    min-width: 44px;\n    max-width: 44px;\n    height: 44px;\n    border-radius: 50%;\n}\n\n.profile-dropdown .profile-pic img {\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.profile-dropdown .profile-info {\n    margin-left: 16px;\n}\n\n.profile-dropdown .profile-name {\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 21px;\n    margin-bottom: 1px;\n    color: #00033F;\n    text-align: left;\n}\n\n.profile-dropdown .profile-role {\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 18px;\n    text-align: left;\n}\n\n.profile-dropdown .dropdown-toggle::after {\n    content: \"\\e903\";\n    font-family: 'icomoon' !important;\n    border: none;\n    width: 18px;\n    height: 18px;\n    color: var(--secondary);\n    font-size: 18px;\n    list-style: 18px;\n}\n\n.profile-dropdown .dropdown-menu {\n    padding: 0;\n    border: 1px solid var(--border);\n    padding: 6px;\n    margin-top: 14px !important;\n}\n\n.profile-dropdown .dropdown-menu .dropdown-item {\n    padding: 8px 12px;\n    font-size: 16px;\n    line-height: 20px;\n    color: var(--secondary);\n    border-radius: 6px;\n    border: 0;\n    transition: all 0.3s ease;\n}\n\n.profile-dropdown .dropdown-menu .dropdown-item:hover {\n    color: var(--white);\n    background: var(--primary);\n}\n\n.sidebar {\n    min-height: calc(100dvh - 78px);\n    min-width: 280px;\n    max-width: 280px;\n    border-right: 1px solid var(--border);\n    padding: 24px 14px;\n    display: flex;\n    flex-direction: column;\n}\n\n.sidebar-menu {\n    list-style: none;\n    padding: 0;\n    margin: 0 0 24px;\n}\n\n.sidebar-link,\n.sidebar-menu .submenu li a {\n    padding: 0;\n    list-style: none;\n    padding: 15px 24px;\n    border-radius: 16px;\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    color: var(--secondary);\n    border: 0;\n    background: transparent;\n    border: 1px solid var(--white);\n    transition: all 0.3s ease;\n}\n\n.sidebar-link .icon,\n.sidebar-menu .submenu li a .icon {\n    min-width: 32px;\n    max-width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 24px;\n    font-size: 30px;\n    line-height: 30px;\n}\n\n.sidebar-link:hover,\n.sidebar-link.active,\n.sidebar-menu .submenu li a:hover,\n.sidebar-menu .submenu li a.active {\n    background: var(--primary);\n    color: var(--white);\n}\n\n.sidebar-menu .submenu {\n    padding-left: 15px;\n}\n\n.sidebar-menu .submenu li a {\n    padding: 16px;\n}\n\n.sidebar-menu .submenu li a .icon {\n    margin-right: 20px;\n}\n\n.signout-button {\n    margin-top: auto;\n}\n\n.signout-button .btns {\n    max-width: 185px;\n    width: 100%;\n    margin: 0 auto;\n    padding: 11px 23px;\n    font-size: 16px;\n    line-height: 20px;\n    font-weight: 400;\n    gap: 10px;\n    background: #635EEC;\n    border: 1px solid #635EEC;\n    box-shadow: 0px 20px 50px 0px #3745571A;\n    transition: all 0.3s ease;\n}\n\n.signout-button .btns .icon {\n    min-width: 32px;\n    max-width: 32px;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 26px;\n    line-height: 26px;\n}\n\n.signout-button .btns:hover {\n    background: var(--white);\n    border: 1px solid #635EEC;\n    box-shadow: 0px 20px 50px 0px #3745571A;\n}\n\n.close-button {\n    display: none;\n    border: 0;\n    padding: 0;\n    background: transparent;\n    width: fit-content;\n    font-size: 16px;\n    line-height: 16px;\n    color: var(--primary);\n    margin-left: auto;\n    margin-top: -6px;\n    margin-bottom: 6px;\n}\n\n.admin-page {\n    padding: 24px 40px;\n}\n\n.admin-page-title {\n    margin-bottom: 24px;\n}\n\n.page-section-title {\n    font-weight: 600;\n    font-size: 30px;\n    line-height: 45px;\n    color: #00033F;\n    margin-bottom: 0;\n}\n\n.admin-page-title .btns {\n    width: fit-content;\n    padding: 11px 23px;\n    font-size: 16px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 12px;\n    font-weight: 500;\n    gap: 8px;\n    text-decoration: unset;\n}\n\n.admin-page-title .btns i {\n    display: flex;\n    font-size: 16px;\n    line-height: 16px;\n}\n\n.buildings-filter,\n.import_filter {\n    padding: 24px;\n    border: 1px solid var(--border);\n    border-radius: 16px;\n    gap: 16px;\n    margin-bottom: 24px;\n}\n\n.buildings-filter .form-control {\n    min-height: 48px;\n    font-size: 14px;\n    list-style: 20px;\n    border-radius: 12px;\n}\n\n.buildings-filter .form-row {\n    max-width: 436px;\n    width: 100%;\n    gap: 16px;\n}\n\n.buildings-filter .form-group {\n    width: 100%;\n}\n\n.buildings-filter .search-icon {\n    position: relative;\n}\n\n.buildings-filter .search-icon .form-control {\n    padding-left: 56px;\n}\n\n.buildings-filter .search-icon i {\n    font-size: 22px;\n    line-height: 22px;\n    color: var(--secondary);\n    position: absolute;\n    top: 13px;\n    left: 24px;\n}\n\n.custom-select .css-13cymwt-control,\n.custom-select .css-t3ipsp-control,\n.custom-select .css-3iigni-container .css-16xfy0z-control {\n    background: transparent;\n    min-height: 48px;\n    border: 1px solid var(--border);\n    border-radius: 12px;\n    box-shadow: unset !important;\n}\n\n.custom-select .css-1jqq78o-placeholder {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.custom-select .css-3iigni-container .css-16xfy0z-control {\n    background: #EEEEEE;\n}\n\n.custom-select .css-t3ipsp-control:hover {\n    border: 1px solid var(--border);\n}\n\n.custom-select .css-t3ipsp-control {\n    border: 1px solid var(--primary);\n}\n\n.custom-select .css-19bb58m {\n    font-size: 16px;\n    line-height: 20px;\n    font-family: 'Poppins';\n}\n\n.custom-select .css-1u9des2-indicatorSeparator {\n    display: none;\n}\n\n.custom-select .css-tj5bde-Svg {\n    fill: var(--secondary);\n    stroke: var(--secondary);\n}\n\n.common-table {\n    border: 1px solid var(--border);\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.common-table .table-wrpper {\n    overflow: auto;\n}\n\n.common-table table {\n    width: 100%;\n}\n\n.common-table table thead th {\n    background: #E9E9FC;\n    padding: 24px 16px;\n    font-size: 15px;\n    line-height: 23px;\n    font-weight: 600;\n    white-space: nowrap;\n    border-bottom: 1px solid #D5D5D5;\n}\n\n.common-table table tbody td {\n    padding: 16px;\n    font-size: 14px;\n    line-height: 21px;\n    color: #00033F;\n    font-weight: 400;\n    vertical-align: middle;\n    border-bottom: 1px solid var(--border);\n}\n\n.properties-listing .common-table table tbody td {\n    border-bottom: 0;\n}\n\n.properties-listing .common-table table .period-tr td {\n    padding: 12px 16px;\n    border-bottom: 1px solid var(--border);\n}\n\n.common-table .period-item {\n    display: flex;\n    align-items: center;\n    margin-bottom: 48px;\n}\n\n.common-table .period-item:last-child {\n    margin-bottom: 0;\n}\n\n.common-table .period-item p {\n    margin-bottom: 0;\n    color: #000214;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    margin-right: 8px;\n}\n\n.common-table .period-item ul {\n    list-style: none;\n    padding: 0;\n    gap: 12px;\n    margin-bottom: 0;\n}\n\n.common-table .period-item ul li {\n    padding: 4px 8px;\n    background: #E9E9FC;\n    border-radius: 8px;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    color: #000214;\n    gap: 12px;\n    display: flex;\n    align-items: center;\n}\n\n.common-table .period-item ul li span {\n    white-space: nowrap;\n}\n\n.common-table .status {\n    display: flex;\n    width: fit-content;\n    padding: 2px 14px;\n    background: #00AC34;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 21px;\n    border-radius: 50px;\n    color: var(--white);\n    margin-bottom: 0;\n}\n\n/* Client 2026-09-11: three property statuses. The base rule above was hardcoded\n   green with no modifier, so every badge looked Active whatever the value. Green\n   stays Active; Inactive is neutral grey (kept for reference, nothing to act on)\n   and Training amber, so a sandbox copy is obvious at a glance. Both are excluded\n   from the Dashboard totals. */\n.common-table .status.active {\n    background: #00AC34;\n}\n\n.common-table .status.inactive {\n    background: #6B7280;\n}\n\n.common-table .status.training {\n    background: #D97706;\n}\n\n/* Rows-per-page selector on the Properties Listing (client 2026-09-15: \"display\n   more than 10 lines … we can go for 100\"). Sized down from the full .form-control\n   so it sits on the pagination line instead of dominating it. */\n.pagination-info .rows-per-page {\n    white-space: nowrap;\n    color: var(--secondary);\n}\n\n.pagination-info .rows-per-page .form-control {\n    width: auto;\n    min-height: 34px;\n    padding: 0 10px;\n    border-radius: 8px;\n    font-size: 14px;\n    cursor: pointer;\n}\n\n/* Status is editable straight from the listing (client 2026-09-11). The <select>\n   keeps the pill look of the badge it replaces — same radius, same colour per\n   state — so the column still reads as a status at a glance rather than as a form\n   control. appearance:none drops the native chrome; the caret is drawn as an\n   inline SVG background so it stays white on every colour. */\n.common-table .status-select {\n    /* The badge rule this inherits sets display:flex, which browsers handle\n       inconsistently on a <select> — pin it back to inline-block. */\n    display: inline-block;\n    line-height: 21px;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    border: none;\n    padding: 2px 30px 2px 14px;\n    cursor: pointer;\n    font-family: inherit;\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%23ffffff' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 12px center;\n}\n\n.common-table .status-select:focus-visible {\n    outline: 2px solid var(--primary);\n    outline-offset: 2px;\n}\n\n.common-table .status-select:disabled {\n    opacity: 0.6;\n    cursor: progress;\n}\n\n/* The dropdown list itself is drawn by the OS, so its options need readable\n   colours rather than white-on-white. */\n.common-table .status-select option {\n    background: var(--white);\n    color: var(--secondary);\n}\n\n/* Sortable column headers on the Properties Listing. The arrow is always present\n   (dimmed until the column is the active sort) so the header does not jump width\n   when the user clicks it. */\n.common-table th.sortable-th {\n    cursor: pointer;\n    user-select: none;\n    white-space: nowrap;\n    transition: color 0.2s ease;\n}\n\n.common-table th.sortable-th:hover {\n    color: var(--primary);\n}\n\n.common-table th.sortable-th .sort-arrow {\n    margin-left: 6px;\n    font-size: 11px;\n    opacity: 0.35;\n}\n\n.common-table th.sortable-th.sorted {\n    color: var(--primary);\n}\n\n.common-table th.sortable-th.sorted .sort-arrow {\n    opacity: 1;\n}\n\n.common-table .button-group {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.common-table .button-group .btns-table,\n.period-table .btns-table {\n    border: 1px solid #E9E9FC;\n    background: #E9E9FC;\n    border-radius: 8px;\n    padding: 7px 15px;\n    text-decoration: unset;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    color: #635EEC;\n    transition: all 0.3s ease-in-out;\n}\n\n.common-table .button-group .btns-table i,\n.period-table .btns-table i {\n    display: flex;\n    font-size: 16px;\n    line-height: 16px;\n}\n\n\n.common-table .button-group .btns-table.edit-btn {\n    background: #D9FFFA;\n    color: #00AC34;\n    border: 1px solid #D9FFFA;\n}\n\n.common-table .button-group .btns-table.delete-btn {\n    background: #FFE7E7;\n    color: #DC3545;\n    border: 1px solid #FFE7E7;\n}\n\n.common-table .button-group .btns-table.duplicate-btn {\n    background: #20c997;\n    color: #ffffff;\n    border: 1px solid #20c997;\n}\n\n.common-table .button-group .btns-table:hover,\n.common-table .button-group .btns-table.edit-btn:hover,\n.period-table .btns-table:hover {\n    background: var(--primary);\n    color: var(--white);\n    border: 1px solid var(--primary);\n}\n\n.common-table .button-group .btns-table.edit-btn:hover {\n    color: var(--white);\n    background: #00AC34;\n    border: 1px solid #00AC34;\n}\n\n.common-table .button-group .btns-table.delete-btn:hover {\n    color: var(--white);\n    background: #DC3545;\n    border: 1px solid #DC3545;\n}\n\n.common-table .button-group .btns-table.duplicate-btn:hover {\n    color: var(--white);\n    background: #17a2b8;\n    border: 1px solid #17a2b8;\n}\n\n/* Cost Fields Section Styling */\n.cost-fields-section {\n    margin-top: 20px;\n}\n\n.cost-field-group {\n    background: #f8f9fa;\n    border: 1px solid #e9ecef !important;\n    border-radius: 8px;\n}\n\n.cost-field-group h6 {\n    color: var(--primary);\n    font-weight: 600;\n    margin-bottom: 15px;\n}\n\n.cost-field-group .form-group label {\n    font-weight: 500;\n    color: #495057;\n    margin-bottom: 8px;\n}\n\n.common-table .button-group .remove-btn {\n    background: #FFDCD9;\n    border: 1px solid #FFDCD9;\n    color: #EF3826;\n}\n\n.common-table .button-group .remove-btn:hover {\n    color: var(--white);\n    background: #EF3826;\n    border: 1px solid #EF3826;\n}\n\n.common-table table tr:last-child td {\n    border: 0;\n}\n\n.properties-listing .page-section-title {\n    margin-bottom: 24px;\n}\n\n.back-title {\n    margin-bottom: 24px;\n}\n\n.back-btn-title {\n    background: transparent;\n    border: 0;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--secondary);\n    padding: 0;\n    margin-right: 8px;\n    font-size: 20px;\n    line-height: 20px;\n    transition: all 0.3s ease-in-out;\n}\n\n.back-btn-title:hover {\n    color: var(--primary);\n}\n\n.create-building-form {\n    max-width: 824px;\n    width: 100%;\n}\n\n/* Client 2026-09-09: \"Can we set create/edit building page in full width like\n   create/edit key page\". The key page is full width because its own\n   `.create-key-form-box { max-width: 824px }` rule is commented out.\n   The same cannot simply be deleted here: `.create-building-form` is shared by FOUR\n   pages — Create/Edit Building, Add/Edit Team, Import Data and the unused\n   CreateBuilding-only-create — and only the building page was asked about. So the cap\n   is lifted through a modifier the building form opts into, leaving the other pages\n   exactly as they are. Add `form-full-width` alongside the base class to widen another\n   page later. */\n.create-building-form.form-full-width {\n    max-width: none;\n}\n\n.create-building-form .form-group label {\n    color: #000214;\n}\n\n.create-building-form .form-control {\n    background: var(--white);\n    min-height: 48px;\n}\n\n.create-building-form textarea.form-control,\ntextarea.form-control {\n    min-height: 100px;\n    padding: 16px;\n}\n\n.create-building-form .custom-select .css-13cymwt-control,\n.create-building-form .custom-select .css-t3ipsp-control {\n    background: var(--white);\n}\n\n.create-building-form .button-group {\n    display: flex;\n    gap: 32px;\n}\n\n.create-building-form .button-group .btns {\n    width: fit-content;\n    min-width: 182px;\n    padding: 11px 24px;\n    font-size: 16px;\n    line-height: 24px;\n    font-weight: 500;\n    border-radius: 12px;\n}\n\n.create-building-form .button-group .btns.cancel-btns {\n    border: 1px solid #EF3826;\n    color: #EF3826;\n    background: transparent;\n}\n\n.create-building-form .button-group .btns.cancel-btns:hover {\n    color: var(--white);\n    background: #EF3826;\n}\n\n.date-picker .react-datepicker-wrapper {\n    width: 100%;\n}\n\n.date-picker {\n    position: relative;\n}\n\n.date-picker .form-control {\n    padding-right: 40px;\n}\n\n.date-picker .icon {\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 22px;\n    line-height: 22px;\n    color: var(--secondary);\n    position: absolute;\n    top: 11px;\n    right: 16px;\n    pointer-events: none;\n}\n\n.bar-button {\n    width: 32px;\n    height: 32px;\n    font-size: 20px;\n    line-height: 20px;\n    display: none;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    border: 0;\n    padding: 0;\n}\n\n.border-btns-copy {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid #635EEC;\n    color: #635EEC;\n    font-size: 16px;\n    line-height: 24px;\n    padding: 7px 15px;\n    font-weight: 500;\n    border-radius: 8px;\n    background: transparent;\n    text-decoration: unset;\n    gap: 8px;\n    transition: all 0.3s ease-in-out;\n}\n\n.border-btns-copy i {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    font-size: 20px;\n    line-height: 20px;\n}\n\n.border-btns-copy:hover {\n    background: #635EEC;\n    color: var(--white);\n}\n\n.build-details-wrapper {\n    margin-bottom: 40px;\n}\n\n.build-box-title {\n    color: #000214;\n    font-size: 24px;\n    line-height: 32px;\n    font-weight: 600;\n    margin-bottom: 16px;\n}\n\n.build-details-card {\n    padding: 24px;\n    background: var(--white);\n    box-shadow: 2px 2px 20px 0px #0000000A;\n    border-radius: 16px;\n}\n\n.build-details-card ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.build-details-card li:not(:last-child) {\n    margin-bottom: 24px;\n}\n\n.build-details-card li label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 16px;\n    line-height: 20px;\n    margin-bottom: 8px;\n    font-weight: 500;\n}\n\n.build-details-card li p {\n    color: #000214;\n    font-size: 18px;\n    line-height: 24px;\n    font-weight: 500;\n    margin-bottom: 0;\n}\n\n.build-details-card.build-full-active {\n    padding-right: 150px;\n    position: relative;\n}\n\n.build-details-card.build-full-active .row {\n    --bs-gutter-y: 24px;\n}\n\n.build-full-active .status {\n    padding: 4px 24px;\n    background: #00AC34;\n    color: var(--white);\n    width: fit-content;\n    margin: 0;\n    border-radius: 50px;\n    position: absolute;\n    top: 24px;\n    right: 24px;\n    font-size: 16px;\n    line-height: 24px;\n}\n\n.period-box-title {\n    margin-bottom: 24px;\n}\n\n.period-box-title .period-date {\n    background: #E9E9FC;\n    padding: 4px 8px;\n    border-radius: 8px;\n    display: flex;\n    gap: 12px;\n    color: #000214;\n    font-size: 16px;\n    line-height: 20px;\n    font-weight: 500;\n}\n\n.period-box-title .period-date p {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    white-space: nowrap;\n    color: #000214;\n    font-size: 16px;\n    line-height: 20px;\n    font-weight: 500;\n}\n\n.period-box-title .period-date p i {\n    min-width: 20px;\n    max-width: 20px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--secondary);\n    font-size: 18px;\n    line-height: 18px;\n}\n\n.period-table {\n    overflow-x: auto;\n}\n\n.period-table table {\n    width: 100%;\n}\n\n.period-table thead th {\n    font-size: 18px;\n    line-height: 24px;\n    color: var(--secondary);\n    font-weight: 500;\n    padding: 0 12px 19px;\n    white-space: nowrap;\n}\n\n.period-table tbody td {\n    font-size: 16px;\n    line-height: 24px;\n    color: #000214;\n    font-weight: 500;\n    padding: 19px 12px;\n    vertical-align: middle;\n}\n\n.period-table tbody td:first-child,\n.period-table thead th:first-child {\n    padding-left: 0;\n}\n\n.period-table tbody td:last-child,\n.period-table thead th:last-child {\n    padding-right: 0;\n}\n\n.period-table .btns-table {\n    width: fit-content;\n    margin-left: auto;\n}\n\n.period-table tbody tr:last-child td {\n    padding-bottom: 0;\n}\n\n.table-pagination {\n    font-size: 14px;\n    line-height: 21px;\n    color: #656671;\n    font-weight: 500;\n}\n\n.pagination-controls {\n    border: 1px solid #D5D5D5;\n    border-radius: 8px;\n    min-width: 86px;\n}\n\n.pagination-controls .btns-table {\n    border: 0;\n    padding: 0;\n    flex: 1;\n    background: transparent;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2px 10px;\n    color: #000214;\n    transition: all 0.3s ease-in-out;\n}\n\n.pagination-controls .btns-table.next-btn {\n    border-left: 1px solid #D5D5D5;\n}\n\n.pagination-controls .btns-table:disabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n}\n\n.pagination-controls .btns-table i {\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    line-height: 12px;\n}\n\n.pagination-controls .btns-table:hover {\n    color: var(--primary);\n}\n\n.period-list .period-item {\n    margin-bottom: 48px;\n}\n\n.period-list .period-item:last-child {\n    margin-bottom: 0;\n}\n\n/* Period actions on building details should match table action buttons */\n.period-box-title .button-group {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.period-box-title .button-group .btns-table {\n    border: 1px solid #E9E9FC;\n    background: #E9E9FC;\n    border-radius: 8px;\n    padding: 7px 15px;\n    text-decoration: unset;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    color: #635EEC;\n    transition: all 0.3s ease-in-out;\n}\n\n.period-box-title .button-group .btns-table i {\n    display: flex;\n    font-size: 16px;\n    line-height: 16px;\n}\n\n.period-box-title .button-group .btns-table.edit-btn {\n    background: #D9FFFA;\n    color: #00AC34;\n    border: 1px solid #D9FFFA;\n}\n\n.period-box-title .button-group .btns-table.delete-btn {\n    background: #FFE7E7;\n    color: #DC3545;\n    border: 1px solid #FFE7E7;\n}\n\n.period-box-title .button-group .btns-table:hover {\n    background: var(--primary);\n    color: var(--white);\n    border: 1px solid var(--primary);\n}\n\n.period-box-title .button-group .btns-table.edit-btn:hover {\n    color: var(--white);\n    background: #00AC34;\n    border: 1px solid #00AC34;\n}\n\n.period-box-title .button-group .btns-table.delete-btn:hover {\n    color: var(--white);\n    background: #DC3545;\n    border: 1px solid #DC3545;\n}\n\n/* Copy mode indicator for building edit page */\n.period-copy-badge {\n    margin-left: 12px;\n    padding: 4px 12px;\n    border-radius: 999px;\n    font-size: 13px;\n    line-height: 18px;\n    font-weight: 500;\n    background: #E9E9FC;\n    color: #635EEC;\n}\n\n.btn-text {\n    background: transparent;\n    border: 0;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--primary);\n    font-weight: 600;\n    gap: 4px;\n    padding: 0;\n    transition: all 0.3s ease-in-out;\n}\n\n.btn-text .icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    line-height: 14px;\n}\n\n.btn-text:hover {\n    color: var(--secondary);\n}\n\n.managing-input {\n    margin-top: 14px;\n}\n\n.remove-btn {\n    color: #EF3826;\n}\n\n.remove-btn:hover {\n    color: var(--primary);\n}\n\n.remove-btn .icon {\n    font-size: 12px;\n    line-height: 12px;\n}\n\n.managing-input .remove-btn {\n    width: fit-content;\n    margin-left: auto;\n}\n\n.access-level-check {\n    display: flex;\n}\n\n.access-level-check .form-check-label span {\n    padding-left: 32px;\n}\n\n.access-level-check .form-check-label span::before {\n    width: 20px;\n    height: 20px;\n    font-size: 12px;\n    line-height: 12px;\n    font-weight: 600;\n}\n\n.import-data-page .page-section-title {\n    margin-bottom: 24px;\n}\n\n.import-data-page .create-building-form {\n    max-width: 100%;\n    margin-bottom: 40px;\n    border: 1px solid #6534401A;\n    background: var(--white);\n}\n\n.import_filter .row {\n    --bs-gutter-y: 24px;\n}\n\n.radio_list_import {\n    gap: 24px;\n    margin-bottom: 24px;\n}\n\n.radio_list_import label {\n    display: flex;\n    position: relative;\n}\n\n.radio_list_import label input {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 0;\n    height: 0;\n    opacity: 0;\n}\n\n.radio_list_import label span {\n    display: flex;\n    min-width: 275px;\n    background: var(--white);\n    align-items: center;\n    justify-content: center;\n    color: #00033F;\n    font-size: 18px;\n    line-height: 24px;\n    font-weight: 500;\n    padding: 15px 20px;\n    cursor: pointer;\n    border: 1px solid #635EEC;\n    border-radius: 12px;\n    transition: all 0.3s ease-in-out;\n}\n\n.radio_list_import label input:checked~span {\n    background: var(--primary);\n    color: var(--white);\n}\n\n.uploaded-surface-section .inner-title {\n    font-size: 18px;\n    line-height: 27px;\n    color: #000214;\n    font-weight: 500;\n    margin-bottom: 24px;\n}\n\n.uploaded-area-box .dropzone-box {\n    min-height: 240px;\n    border: 2px dashed var(--secondary);\n    display: flex;\n    padding: 16px;\n    align-items: center;\n    justify-content: center;\n    border-radius: 12px;\n}\n\n.uploaded-area-box .dropzone-content {\n    max-width: 261px;\n    width: 100%;\n    margin: 0 auto;\n}\n\n.uploaded-area-box .dropzone-content .icon {\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto 7px;\n    font-size: 32px;\n    line-height: 32px;\n    color: var(--secondary);\n}\n\n.uploaded-area-box .dropzone-content p {\n    text-align: center;\n    font-size: 18px;\n    line-height: 27px;\n    color: var(--secondary);\n    margin-bottom: 0;\n}\n\n.uploaded-surface-box {\n    width: 100%;\n    padding: 24px;\n    background: var(--white);\n    border-radius: 12px;\n}\n\n.uploaded-surface-box .inner-title {\n    margin-bottom: 20px;\n}\n\n.uploaded-surface-item {\n    padding: 16px 53px 16px 24px;\n    background: #E9E9FC;\n    border-radius: 12px;\n    position: relative;\n    margin-bottom: 12px;\n}\n\n.uploaded-surface-item:last-child {\n    margin-bottom: 12px;\n}\n\n.uploaded-surface-item .title-icon {\n    width: 100%;\n}\n\n.uploaded-surface-item .title-icon .icon {\n    min-width: 24px;\n    max-width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 24px;\n    line-height: 24px;\n    color: #0F172A;\n    margin-right: 10px;\n}\n\n.uploaded-surface-item .title-icon p {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: block;\n    max-width: 100%;\n    font-size: 14px;\n    line-height: 21px;\n    font-weight: 400;\n    color: var(--secondary);\n}\n\n.uploaded-surface-item .remove-btn {\n    width: 16px;\n    height: 16px;\n    background: transparent;\n    border: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    line-height: 12px;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 24px;\n}\n\n.import-step-date {\n    gap: 350px;\n    margin-bottom: 24px;\n}\n\n.import-step-date .step {\n    min-width: 60px;\n    height: 60px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid var(--border);\n    color: var(--primary);\n    position: relative;\n    border-radius: 12px;\n    font-size: 24px;\n    line-height: 36px;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n}\n\n.import-step-date .step::before {\n    content: '';\n    width: 340px;\n    height: 2px;\n    background: var(--border);\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: -345px;\n    pointer-events: none;\n    border-radius: 2px;\n}\n\n.import-step-date .step:first-child:before {\n    display: none;\n}\n\n.import-step-date .step.active::before {\n    background: var(--primary);\n}\n\n.import-step-date .step.active,\n.import-step-date .step:hover {\n    border: 1px solid var(--primary);\n}\n\n.import-step-date .step.previous {\n    background: var(--primary);\n    color: var(--white);\n    border: 1px solid var(--primary);\n}\n\n/* Imported Data List Styles */\n.imported-data-page {\n    padding: 20px;\n}\n\n.imported-inline-edit-input {\n    width: 100%;\n    min-width: 110px;\n    padding: 6px 8px;\n    border: 1px solid #ced4da;\n    border-radius: 4px;\n    background: #fff;\n    font-size: 0.9rem;\n}\n\n.imported-inline-edit-input:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n.imported-data-summary {\n    background: #f8f9fa;\n    padding: 15px;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    display: flex;\n    gap: 30px;\n}\n\n.imported-data-summary p {\n    margin: 0;\n    font-weight: 600;\n    color: #495057;\n}\n\n.building-group {\n    background: #fff;\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    overflow: hidden;\n}\n\n.building-header {\n    background: var(--primary);\n    color: white;\n    padding: 15px 20px;\n}\n\n.building-header h3 {\n    margin: 0 0 5px 0;\n    font-size: 1.2rem;\n}\n\n.building-info {\n    display: flex;\n    gap: 20px;\n    font-size: 0.9rem;\n}\n\n.building-info span {\n    opacity: 0.9;\n}\n\n.period-group {\n    border-bottom: 1px solid #e9ecef;\n}\n\n.period-group:last-child {\n    border-bottom: none;\n}\n\n.period-header {\n    background: #f8f9fa;\n    padding: 12px 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid #e9ecef;\n}\n\n.period-header h4 {\n    margin: 0;\n    font-size: 1rem;\n    color: #495057;\n    flex-grow: 1;\n}\n\n.record-count {\n    background: #6c757d;\n    color: white;\n    padding: 2px 8px;\n    border-radius: 12px;\n    font-size: 0.8rem;\n}\n\n.records-list {\n    padding: 0;\n}\n\n.record-item {\n    padding: 15px 20px;\n    border-bottom: 1px solid #f1f3f4;\n}\n\n.record-item:last-child {\n    border-bottom: none;\n}\n\n.record-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.record-id {\n    font-weight: 600;\n    color: var(--primary);\n}\n\n.record-date {\n    color: #6c757d;\n    font-size: 0.9rem;\n}\n\n.record-details {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 10px;\n}\n\n.detail-item {\n    font-size: 0.9rem;\n}\n\n.detail-item strong {\n    color: #495057;\n    display: block;\n    margin-bottom: 2px;\n}\n\n.pagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 15px;\n    margin-top: 30px;\n    padding: 20px;\n}\n\n.page-info {\n    font-weight: 600;\n    color: #495057;\n}\n\n.no-data {\n    text-align: center;\n    padding: 60px 20px;\n    color: #6c757d;\n}\n\n.no-data p {\n    font-size: 16px;\n    margin: 0;\n}\n\n.multi-custom-select .costs-select__multi-value,\n.multi-custom-select .costs-select__clear-indicator {\n    display: none;\n}\n\n.multi-custom-option {\n    padding: 0;\n    margin-bottom: 0;\n}\n\n.multi-custom-option li {\n    padding: 6px 12px;\n    background: var(--secondary);\n    border-radius: 4px;\n    color: var(--white);\n    font-size: 16px;\n    line-height: 20px;\n    font-weight: 400;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: fit-content;\n    gap: 4px;\n}\n\n.multi-custom-option li span {\n    width: 16px;\n    height: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    line-height: 12px;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n}\n\n/* .create-key-form-box {\n    max-width: 824px;\n    width: 100%;\n} */\n\n.key-card {\n    padding: 24px;\n    box-shadow: 4px 4px 40px 0px #0000000A;\n    border-radius: 16px;\n}\n\n.calculation-label {\n    margin-bottom: 14px;\n}\n\n.calculation-label .arrow-btn {\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid var(--primary);\n    background: var(--primary);\n    font-size: 14px;\n    line-height: 14px;\n    color: var(--white);\n    border-radius: 4px;\n    transition: all 0.3s ease-in-out;\n}\n\n.calculation-label .arrow-btn:hover {\n    background: var(--white);\n    color: var(--primary);\n}\n\n.variable-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 5px 11px;\n    border-radius: 4px;\n    background: var(--secondary);\n    font-size: 16px;\n    line-height: 20px;\n    font-weight: 400 !important;\n    color: var(--white);\n    cursor: pointer;\n    border: 1px solid var(--secondary) !important;\n    transition: all 0.3s ease-in-out;\n}\n\n.variable-btn:hover {\n    color: var(--secondary);\n    background: var(--white);\n}\n\n.operator-btn {\n    padding: 0;\n    width: 32px;\n    height: 32px;\n    border: 1px solid var(--secondary);\n    border-radius: 4px;\n    font-size: 16px;\n    line-height: 20px;\n    color: var(--primary);\n    transition: all 0.3s ease-in-out;\n}\n\n.operator-btn:hover {\n    background: var(--primary);\n    color: var(--white);\n    border: 1px solid var(--primary);\n}\n\n.form-radio-label span::before {\n    width: 20px;\n    height: 20px;\n    border: 2px solid var(--primary);\n    border-radius: 50%;\n}\n\n.form-radio-label span {\n    padding-left: 30px;\n    font-size: 16px;\n    line-height: 20px;\n    color: #000214;\n    font-weight: 500;\n}\n\n.form-radio-label span::after {\n    content: '';\n    width: 12px;\n    height: 12px;\n    background: var(--primary);\n    border-radius: 50%;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 4px;\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.3s ease-in-out;\n}\n\n.form-radio-label input:checked~span::before {\n    background: transparent;\n}\n\n.form-radio-label input:checked~span::after {\n    opacity: 1;\n    visibility: visible;\n}\n\n.create-key-form-box .form-group label {\n    color: #000214;\n}\n\n.create-key-form-box .form-group label span {\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--secondary);\n    font-weight: 400;\n}\n\n.destination-title h6 {\n    margin-bottom: 0;\n    font-size: 20px;\n    line-height: 24px;\n    color: #000214;\n    font-weight: 600;\n}\n\n.destination-title .add-more-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    border: 0;\n    gap: 8px;\n    font-size: 16px;\n    line-height: 16px;\n    color: var(--primary);\n    padding: 0;\n    transition: all 0.3s ease-in-out;\n}\n\n.destination-title .add-more-btn:hover {\n    color: var(--black);\n}\n\n.destination-title .add-more-btn i {\n    display: flex;\n    font-size: 14px;\n    line-height: 14px;\n}\n\n/* Building and Period Sections */\n.building-section {\n    margin-bottom: 40px;\n}\n\n.period-section {\n    margin-bottom: 30px;\n}\n\n.section-header {\n    background: var(--primary);\n    color: white;\n    padding: 15px 20px;\n    margin: 0 0 20px 0;\n    border-radius: 8px;\n    font-size: 1.2rem;\n    font-weight: 600;\n}\n\n/* Create Key specific styles */\n.btn-danger.btn-sm {\n    background: #dc3545;\n    border-color: #dc3545;\n    color: white;\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-size: 12px;\n    border: 1px solid #dc3545;\n}\n\n.btn-danger.btn-sm:hover {\n    background: #c82333;\n    border-color: #bd2130;\n}\n\n.arrow-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.create-key-form-box .form-control {\n    min-height: 48px;\n}\n\n.create-key-form-box .form-group label {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.destination-key-card .row {\n    --bs-gutter-y: 24px;\n}\n\n/* Dashboard Page */\n.dashboard-page .dashboard-header {\n    margin-bottom: 32px;\n}\n\n.dashboard-page .dashboard-subtitle {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--secondary);\n    margin-bottom: 0;\n    margin-top: 6px;\n}\n\n/* Stat Cards */\n.stat-card {\n    background: var(--white);\n    border-radius: 16px;\n    border: 1px solid var(--border);\n    padding: 20px 24px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    box-shadow: 2px 2px 20px 0px #0000000A;\n    transition: box-shadow 0.3s ease;\n}\n\n.stat-card:hover {\n    box-shadow: 2px 4px 28px 0px #0000001A;\n}\n\n.stat-card-body {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    border-left: 3px solid var(--secondary);\n    padding-left: 16px;\n}\n\n.stat-label {\n    font-size: 14px;\n    line-height: 20px;\n    font-weight: 500;\n    color: var(--secondary);\n    margin-bottom: 0;\n}\n\n.stat-value {\n    font-size: 40px;\n    line-height: 48px;\n    font-weight: 700;\n    color: #00033F;\n    margin-bottom: 0;\n    letter-spacing: -0.5px;\n}\n\n.stat-icon-circle {\n    min-width: 44px;\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    background: var(--secondary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--white);\n    font-size: 20px;\n    line-height: 20px;\n    flex-shrink: 0;\n}\n\n/* Quick Actions */\n.quick-actions-section {\n    margin-top: 8px;\n}\n\n.quick-actions-title {\n    font-size: 22px;\n    line-height: 32px;\n    font-weight: 600;\n    color: #00033F;\n    margin-bottom: 24px;\n}\n\n.quick-action-card {\n    display: flex;\n    flex-direction: column;\n    padding: 28px 24px;\n    background: var(--white);\n    border: 1px solid var(--border);\n    border-radius: 16px;\n    text-decoration: none;\n    color: inherit;\n    box-shadow: 2px 2px 20px 0px #0000000A;\n    transition: all 0.3s ease;\n    height: 100%;\n}\n\n.quick-action-card:hover {\n    border-color: var(--primary);\n    box-shadow: 2px 4px 28px 0px #1B13E31A;\n    color: inherit;\n}\n\n.quick-action-icon {\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    background: var(--secondary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--white);\n    font-size: 20px;\n    line-height: 20px;\n    margin-bottom: 20px;\n}\n\n.quick-action-label {\n    font-size: 18px;\n    line-height: 26px;\n    font-weight: 600;\n    color: var(--secondary);\n    margin-bottom: 6px;\n}\n\n.quick-action-desc {\n    font-size: 14px;\n    line-height: 21px;\n    color: var(--secondary);\n    margin-bottom: 0;\n}\n\n/* ─── My Account Pages ─────────────────────────────────── */\n.my-account-header {\n    margin-bottom: 32px;\n}\n\n.my-account-subtitle {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--secondary);\n    margin-top: 4px;\n    margin-bottom: 0;\n}\n\n.my-account-form {\n    max-width: 824px;\n    width: 100%;\n}\n\n/* Profile photo */\n.profile-photo-wrapper {\n    margin-bottom: 32px;\n}\n\n.profile-photo-circle {\n    position: relative;\n    width: 110px;\n    height: 110px;\n    border-radius: 50%;\n    overflow: visible;\n}\n\n.profile-photo-img {\n    width: 110px;\n    height: 110px;\n    border-radius: 50%;\n    object-fit: cover;\n    display: block;\n}\n\n.profile-photo-edit-btn {\n    position: absolute;\n    bottom: 4px;\n    right: 4px;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background: var(--secondary);\n    border: 2px solid #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    font-size: 14px;\n    line-height: 1;\n    cursor: pointer;\n    transition: background 0.2s ease;\n    padding: 0;\n}\n\n.profile-photo-edit-btn:hover {\n    background: var(--primary);\n}\n\n.my-account-save-btn {\n    min-width: 182px;\n    font-size: 16px;\n    line-height: 24px;\n    font-weight: 500;\n    border-radius: 12px;\n    padding: 11px 24px;\n}\n\n.my-account-form .form-group label {\n    color: #000214;\n}\n\n.my-account-form .form-control {\n    background: #fff;\n    min-height: 55px;\n}\n\n.my-account-form .form-control[readonly] {\n    background: #f5f6f8;\n    cursor: default;\n}\n\n.profile-photo-uploading {\n    position: absolute;\n    inset: 0;\n    border-radius: 50%;\n    background: rgba(0, 0, 0, 0.4);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n}\n\n/* White Labelling toggle */\n.toggle-switch {\n    width: 48px;\n    height: 26px;\n    background: #ccc;\n    border-radius: 13px;\n    position: relative;\n    cursor: pointer;\n    transition: background 0.2s;\n    flex-shrink: 0;\n    user-select: none;\n}\n.toggle-switch.active {\n    background: #4caf50;\n}\n.toggle-knob {\n    position: absolute;\n    top: 3px;\n    left: 3px;\n    width: 20px;\n    height: 20px;\n    background: #fff;\n    border-radius: 50%;\n    transition: left 0.2s;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.2);\n}\n.toggle-switch.active .toggle-knob {\n    left: 25px;\n}\n.logo-preview img {\n    border: 1px solid #e0e0e0;\n    border-radius: 4px;\n    padding: 4px;\n    background: #fff;\n}\n/* Logo upload dropzone */\n.logo-upload-dropzone {\n  border: 2px dashed #c7c9e3;\n  border-radius: 10px;\n  padding: 24px 16px;\n  text-align: center;\n  cursor: pointer;\n  background: #f8f9ff;\n  transition: border-color 0.2s, background 0.2s;\n  user-select: none;\n}\n.logo-upload-dropzone:hover {\n  border-color: #5b5fcf;\n  background: #f0f1ff;\n}\n.logo-upload-icon {\n  margin-bottom: 8px;\n}\n.logo-upload-text {\n  font-size: 14px;\n  color: #555;\n}\n.logo-upload-hint {\n  font-size: 12px;\n  color: #999;\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
